import { z } from "zod";

const nodeSchema = z.object({
  l: z.string(),
  r: z.string(),
});

export const NeighborsDataSchema = z.record(nodeSchema);

export const NeighborsSchema = z.object({
  enabled: z.boolean(),
  modeLr: z.boolean(),
  data: NeighborsDataSchema,
});

